import { RichText } from "@/components/richText/richText.component";
import { Text } from "@/components/text/text.component";

import type { GetHealthPageBySlugQueryResult } from "@/sanity.types";

import { ProductCardListingCard } from "./productCardListingCard.component";

export const ProductCardListing = ({ block }: ProductCardListingProps) => {
  const cards = block?.cards ?? [];
  if (!block?.heading || cards.length === 0) return null;

  const headingId = `product-card-listing-${block._key}`;

  return (
    <section
      data-testid="product-card-listing"
      aria-labelledby={headingId}
      className="w-full bg-white">
      <div className="mx-auto flex w-full max-w-[1440px] flex-col gap-8 px-6 py-10 lg:gap-12 lg:px-12 lg:py-16">
        <Text
          id={headingId}
          variant="h3"
          component="h2"
          className="text-greyscale-headline text-center">
          {block.heading}
        </Text>

        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 md:gap-6 lg:gap-12">
          {cards.map((card) => (
            <ProductCardListingCard key={card._key} card={card} />
          ))}
        </div>

        {block.disclaimer?.length ? (
          <div data-testid="product-card-listing-disclaimer">
            <RichText
              blockComponents={{
                normal: ({ children }) => (
                  <Text
                    variant="legal"
                    component="p"
                    className="text-greyscale-body">
                    {children}
                  </Text>
                ),
              }}>
              {block.disclaimer}
            </RichText>
          </div>
        ) : null}
      </div>
    </section>
  );
};

type HealthPageBlock = NonNullable<
  NonNullable<GetHealthPageBySlugQueryResult>["pageBuilder"]
>[number];

export type ProductCardListingBlock = Extract<
  HealthPageBlock,
  { _type: "productCardListing" }
>;

export type ProductCardListingCardData = NonNullable<
  ProductCardListingBlock["cards"]
>[number];

export type ProductCardListingProps = {
  block: ProductCardListingBlock;
};
